const env = {
  REACT_APP_BACKEND: process.env.REACT_APP_BACKEND,
};

export default env;